<template>
  <div id="projectContent">
    <h3>{{ title }}</h3>
    <div class="content"
         v-html="newHtml">
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {getNewInfo} from "@/api/news";

export default {
  data: () => ({
    title: '',
    index: 0,
    newHtml: '',
    newTitle: '',
  }),
  computed: {
    ...mapState([
      'TabIndex',
    ])
  },
  watch: {
    TabIndex() {
      this.index = this.$route.query.index
      this.changeHtml()
    },
    title(newTitle) {
      this.newTitle = newTitle
      this.changeHtml()
    }
  },
  created() {
    this.newTitle = this.title
  },
  mounted() {
    this.changeHtml()
    console.log('title', this.title)
  },
  methods: {
    async getInfo(id) {
      const res = await getNewInfo({
        id
      })
      this.title = res.data.title
      this.newHtml = res.data.content
    },
    changeHtml() {
      if (this.index == 0) {
        this.getInfo(23)
      } else if (this.index == 1) {
        this.getInfo(24)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#projectContent {
  min-height: 626px;
  width: 100%;
  margin-top: 10px;
  border: 1px #2073dfb4 solid;

  h3 {
    margin: 30px 0;
    font-size: 20px;
    text-align: center;
  }
}

.content {
  padding: 20px;
  padding-top: 0;
}
</style>
